import React from "react";

const PersonaliaPage = () => {
  return <div className="container">Personalia</div>;
};

export default PersonaliaPage;